module.exports = __webpack_public_path__ + "static/assets/160e7ca1ae1002eae8b787664d92e5b0.svg";